export default function initializeMap() {
    var mapBlock = document.querySelectorAll("div.mapblock");
    var addressBlock = document.querySelectorAll("div.addressblock");

    if (addressBlock.length === 0) {
        if (mapBlock.length !== 0) {
            clickedAddress(mapBlock[0].dataset.firstaddress, false, null);
        }
    } else {
        var items = addressBlock[0].childNodes;
        clickedAddress(items[1].dataset.address, true, items[1], items[1].dataset.icurl);
        
        items.forEach(element => {
            element.addEventListener("click", function () {
                clickedAddress(element.dataset.address, true, element, element.dataset.icurl);
            })
        });
    }
}
function clickedAddress(address, showIcon = true, element = null, iconUrl = '') {
    if (element !== null) { 
        highlightAddressItem(element);   
    }

    const xhr = new XMLHttpRequest();
    const url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + address + '.json?access_token=pk.eyJ1IjoiYXBwc3R1ZGlvbmwiLCJhIjoiY2p5c3N2cGJlMG42ajNubm9wczY4a2I4cyJ9.DQxwSR5-qh5Lok2qoVPOQg&cachebuster=1565094686011&autocomplete=false';
    xhr.open("GET", url);
    xhr.send();

    var response = Object;
    var coords = Array;

    xhr.onloadend = (e) => {
        response = JSON.parse(xhr.responseText);
        coords = response['features'][0]['geometry']['coordinates'];

        // console.log(coords);
        mapboxgl.accessToken = 'pk.eyJ1IjoiYXBwc3R1ZGlvbmwiLCJhIjoiY2p5c3N2cGJlMG42ajNubm9wczY4a2I4cyJ9.DQxwSR5-qh5Lok2qoVPOQg';
        var map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/appstudionl/cjystdl2h0vq21ck3z1qx0ua3',
            center: coords,
            zoom: 13
        });

        if (showIcon == true) {
            map.on("load", function () {
                /* Image: An image is loaded and added to the map. */
                map.loadImage(iconUrl, function(error, image) {
                    if (error) throw error;
                    map.addImage("custom-marker", image);
                    map.addLayer({id: "markers", type: "symbol",
                        source: { type: "geojson", data: {
                                type: 'FeatureCollection', features: [{
                                    type: 'Feature', properties: {},
                                    geometry: {
                                        type: "Point",
                                        coordinates: coords
                                    }
                                }] }
                               },
                        layout: {
                            "icon-image": "custom-marker",
                        } });
                });
            });
        }
        xhr.abort();
    }
}
function highlightAddressItem(item) {
    //reset all first
    var items = document.querySelectorAll("div.addressblock div.address");
    items.forEach(element => {
        element.classList.remove("active");
    });
    //add class
    item.classList.add("active");
}